import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";
import LinkInline from "../../elements/LinkInline";

type CguHeaderBodyProps = {
	publicSiteOrigin: string;
};

/** Bloc texte du haut des CGU (hors titre principal), extrait pour **`max-lines-per-function`**. */
export function CguHeaderBody(props: CguHeaderBodyProps): React.JSX.Element {
	const { publicSiteOrigin } = props;
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_LG_SEMIBOLD} color={ETypoColor.TEXT_SECONDARY} italic>
				Version en vigueur à compter du 24 avril 2024
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Les présentes Conditions Générales d&apos;Utilisation sont conclues entre {pub.publisherLegalName}
				{pub.publisherCguIntroAfterPartyName}
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Tout Internaute qui souhaite utiliser le Site
				<LinkInline text={publicSiteOrigin} href={`${publicSiteOrigin}/`} />
				(ci-après, le « Site ») dans sa version ordinateur ou mobile est réputé avoir pris connaissance des présentes conditions
				générales d&apos;utilisation (ci-après, les « CGU »).
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Toute utilisation du Site nécessite la consultation et l&apos;acceptation des présentes conditions générales. L&apos;Internaute
				reconnaît que l&apos;utilisation du Site nécessite le respect de l&apos;ensemble des prescriptions définies au sein des présentes.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Il est tenu à chaque visite de prendre connaissance d&apos;éventuelles évolutions de ces dernières, {pub.publisherLegalName}{" "}
				se réservant le droit de les modifier à tout moment.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Ces conditions générales d&apos;utilisation ne sont pas des conditions générales de vente ou des conditions générales de
				prestations de services.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Elles ont vocation à constituer la règle que doit respecter tout Internaute se rendant sur le Site {pub.publisherLegalName}
			</Typography>
		</>
	);
}
